"use client";
import React, { useEffect, useState } from "react";
import "../styles/Maintenanceservices.css";
import "../styles/Elecinstallation.css"; // Required for the cube animation
import Beams from "./Beams";
import Header from "./Header";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";

// ======= IMAGE IMPORTS =======
import maintenance1 from "../assets/om2.jpg";
import maintenance2 from "../assets/om3.jpeg";
import maintenance3 from "../assets/om4.jpeg";
import maintenance4 from "../assets/om5.jpeg"; 
import maintenance5 from "../assets/om6.jpeg";
import maintenance6 from "../assets/om7.jpeg";

const Maintenanceservices = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />

      {/* ================= HERO SECTION ================= */}
      <div className="maintenance-services-container">
        <div className="epc-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        <div className="maintenance-services-left" data-aos="fade-right">
          <h1>Maintenance Services</h1>
          <p>
            Our Electrical Maintenance Services ensure the safe, efficient, and uninterrupted
            operation of your power systems. With certified engineers and technicians,
            we deliver preventive and corrective maintenance for industrial and utility facilities.
          </p>
        </div>

        {/* ================= RIGHT SIDE CUBE SLIDER ================= */}
        <div className="maintenance-services-right" data-aos="fade-left">
          <div className="elec-installation-cube-wrapper">
            <div className="elec-installation-cube-gallery">
              <img src={maintenance1} alt="Maintenance 1" />
              <img src={maintenance2} alt="Maintenance 2" />
              <img src={maintenance3} alt="Maintenance 3" />
              <img src={maintenance4} alt="Maintenance 4" />
              <img src={maintenance5} alt="Maintenance 5" />
              <img src={maintenance6} alt="Maintenance 6" />
            </div>
          </div>
        </div>
      </div>

      {/* ================= EXTRA CONTENT ================= */}
      <div className="maintenance-extra-footer">
        <h2 className="maintenance-footer-heading" data-aos="fade-in">
          Operation & Maintenance
        </h2>

        <div className="maintenance-footer-top" data-aos="fade-up">
          {/* Using one of the imported images here as well */}
          <img
            src={maintenance2}
            alt="Maintenance Overview"
            className="maintenance-footer-image"
          />
          <p className="maintenance-footer-paragraph">
            As a total solution provider for power & energy systems, Acume meets the
            various needs of customers through excellent services and a strong
            maintenance strategy.
          </p>
        </div>

        <h2 className="maintenance-category-heading">
          Categories of Maintenance
        </h2>

        <div className="maintenance-footer-box-section">
          <div className="maintenance-footer-box" data-aos="fade-right">
            <h3>Preventive Maintenance</h3>
            <p>Performed at predetermined intervals.</p>
            <h4>Routine Maintenance</h4>
            <p>• Scheduled at fixed time intervals.</p>
            <h4>Condition Based Maintenance</h4>
            <p>• Derived from continuous monitoring.</p>
          </div>

          <div className="maintenance-footer-box" data-aos="fade-left">
            <h3>Corrective Maintenance</h3>
            <p>Performed after failure or unacceptable condition.</p>
            <h4>Breakdown Maintenance</h4>
            <p>• Emergency maintenance to prevent danger.</p>
            <h4>Deferred Maintenance</h4>
            <p>• Planned for next available outage.</p>
          </div>
        </div>

        {/* ================= ACCORDION ================= */}
        <div className="maintenance-accordion">
          <button
            className={`maintenance-accordion-header ${open ? "active" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <h2 className="maintenance-footer-bottom-heading">
              Maintenance Activities
            </h2>
            <span className={`accordion-arrow ${open ? "rotate" : ""}`}>
              ▼
            </span>
          </button>

          <div className={`maintenance-accordion-content ${open ? "show" : ""}`}>
            <ul className="maintenance-footer-points">
              {[
                "Plot A - Annual Maintenance - GIS Substation Electrical Maintenance for MBR PHASE III 800 MW PV Solar Project.",
                "Plot B - Annual Maintenance - GIS Substation Electrical Maintenance for MBR PHASE III 800 MW PV Solar Project.",
                "Plot C - Annual Maintenance - GIS Substation Electrical Maintenance for MBR PHASE III 800 MW PV Solar Project.",
                "Shutdown Maintenance of Transformers for TAPCO AGPS.",
                "Annual Periodic Maintenance work for LVAC Panels at Barakah Nuclear Power Plant.",
                "11kV Cable Replacement - F1 IWPP Extension RO Plant - Fujairah.",
                "11kV Cable Testing for RMU including IR, VLF and HV Test.",
                "Primary & Secondary Injection tests at DIP-2 Factory.",
                "Maintenance works of 33kV Switchgear & SCADA systems.",
                "Shutdown Maintenance work at RAK Maritime City.",
                "11kV OHL Testing for FEWA network.",
                "Periodic Maintenance & Testing of MV panel in Sharjah Cement Factory."
              ].map((item, index) => (
                <li key={index}>
                  <span className="maintenance-arrow">★</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Maintenanceservices;